import {
  connect
} from 'react-redux'
import { getCampaignById, getEmailChannelAggregated, getEmailChannelStatsAggregated, setReportDateRange, setSegmentId,
  setChannelCampaignId, getCampaignTopLinkStats, clearCampaignDetail, getCampaignTopLocationClickStats } from '../../actions/Campaign'
import {selectClient} from "../../actions/App";

import EmailChannelReport from '../../components/Campaigns/Report/EmailChannelReport'

const mapStateToProps = (state) => {
  const { clients } = state.app;
  const { emailAggregatedReport, emailAggregatedStats, reportDateRange, campaignDetail, topLinkStats, topLocationOpensStats,
    channelCampaignId, segmentId } = state.campaigns
	return {
    emailAggregatedReport,
    emailAggregatedStats,
    campaignDetail,
    channelCampaignId,
    segmentId,
    topLocationOpensStats,
    topLinkStats,
		reportDateRange : reportDateRange ? reportDateRange : "life-of-campaign",
		client_id: state.app.client_info && state.app.client_info.id,
    client_tz: state.app.client_info && state.app.client_info.timezone,
		client_info: state.app.client_info,
		clients
	}
}

const mapDispatchToProps = (dispatch) => {
  return {
    getCampaignById(id) {
      dispatch(getCampaignById(id, false));
    },
    selectClient(cid) {
			dispatch(selectClient(cid))
    },
    getEmailChannelAggregatedReport(groupCampaignId, deploymentId, dateRange, channelCampaignId) {
      dispatch(getEmailChannelAggregated(groupCampaignId, deploymentId, dateRange, channelCampaignId));
    },
    getEmailChannelStatsAggregated(groupCampaignId, deploymentId, dateRange, channelCampaignId) {
      dispatch(getEmailChannelStatsAggregated(groupCampaignId, deploymentId, dateRange, channelCampaignId));
    },
    getCampaignTopLinkStats(groupCampaignId, campaignid, dateRanges, limit) {
      dispatch(getCampaignTopLinkStats(groupCampaignId, campaignid, dateRanges, limit, "email"));
    },
    getCampaignTopLocationClickStats(groupCampaignId, campaignId, dateRange, limit) {
      dispatch(getCampaignTopLocationClickStats(groupCampaignId, campaignId, dateRange, limit, "email"));
    },
    setReportDateRange(dateRange) {
      dispatch(setReportDateRange(dateRange.value));
    },
    setChannelCampaignId(data) {
      dispatch(setChannelCampaignId(data.value))
    },
    setSegmentId(data) {
      dispatch(setSegmentId(data.value))
    },
    cleanCampaignInfo(cid) {
      dispatch(clearCampaignDetail(cid))
    }
  }
}

const EmailChannelContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(EmailChannelReport)

export default EmailChannelContainer


// WEBPACK FOOTER //
// ./src/containers/Campaigns/EmailChannelReport.js